<template>
  <div class="login">
      <div  v-show="!showReset" class="mt_bl">
            <v-text-field
                label="Почта, либо номер телефона"
                class="inpt"
                hide-details="auto"
                name="phone"
                v-model.trim="phone"
            >
            </v-text-field>
            <div class="error" v-if="$v.password.$dirty && !$v.phone.required">Поле логин обязательно к заполнению</div>
            <div class="error" v-if="!$v.phone.minLength">Поле логин минимальная длина 10 символов.</div>
            
            <v-text-field
                label="Пароль"
                class="inpt"
                hide-details="auto"
                v-model.trim="password"
                name="password"
                type="password"
            ></v-text-field>
            <div class="error" v-if="$v.password.$dirty && !$v.password.required">Поле пароль обязательно к заполнению</div>
            <div class="error" v-if="!$v.password.minLength">Минимальная длина пароля 4 символа.</div>

            <button class="btn" @click="login">
                <span v-show="!viewLoader">
                    Вход
                </span>
                <v-progress-circular v-show="viewLoader" class="loader__color" indeterminate size="24"></v-progress-circular>
            </button>
            <a @click="signIn">
                Регистрация
            </a>
            <a class="mt" @click="resetPassword">
                Забыли пароль?
            </a>
      </div>
      <ResetPassword @signInReset="signInReset"  v-show="showReset" />
  </div>
</template>

<script>
import { required, minLength} from 'vuelidate/lib/validators'
import axios from 'axios'
import {mapActions} from 'vuex'
import ResetPassword from '@/components/ResetPassword'


export default {
  name: 'login',
  components: {
      ResetPassword
  },
  validations: {
      phone: {
          required, minLength: minLength(10)
      },
      password: {
          required, minLength: minLength(4)
      },
  },
  data () {
      return {
         phone: '',
         password: '',
         viewLoader: false,
         showReset: false
      }
  },
  methods: {
    ...mapActions([
        'ADD_USER_DATA',
    ]),
    signIn() {
         this.$emit('signIn')
    },
    signInReset() {
         this.showReset = false
         this.$emit('signInReset')
    },
    resetPassword() {
        this.showReset = true
    },
    login () {
        if (this.$v.$invalid) {
            this.$v.$touch()
            return 
        } else {
            this.viewLoader = true
            axios({
                method: 'post',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                url: this.$apiURI + 'public/login',
                data: {
                    login: this.phone,
                    password: this.password
                }
            })
            .then((response) => {
                this.viewLoader = false
                if (response.data.message == "Combination login|password not found") {
                    this.$toasted.show('Неверный логин или пароль!').goAway(2000)
                    return false
                } 
                if (response.data.message.token !== '') {
                    this.phone = ''
                    this.password = ''
                    this.ADD_USER_DATA(response.data.message)
                    document.querySelector('.modal').style.display = 'none'
                    this.$router.replace({ path: '/profile' }) 
                }
            })
            .catch((error) => {
                console.log(error);
            });
        }
         
    },
  }
}
</script>
<style scoped lang="less">
.login {
    width: 100%;

    .mt_bl {
        text-align: left;
        .mt {
            margin-top: 15px;
        }
        .number_phone {
            position: relative;
            left: 0;
            font-size: 16px;
            top: 4px;
            font-weight: bold;
            margin-right: 5px;
        }
        a {
            text-align: center;
            font-size: 14px;
            text-transform: uppercase;
            color: #000;
            display: block;
            margin: 0 auto;
            cursor: pointer;
        }
        .loader__color {
                color: #fff;
        }
        .inpt {
            width: 100%;
        }
        .error {
            color: red;
            font-size: 11px;
            margin-top: 4px;
        }    
        .btn {
            width: 100%;
            margin-top: 15px;
            margin-bottom: 10px;
            height: 40px;
            background: #90b913;
            color: #fff;
            text-transform: uppercase;
            font-size: 14px;
            &:hover {
                background: #8ba245;
            }
        }
    }
}
</style>